import React, { useState, useEffect } from "react";
import { DayCampPageOptions } from "../Constants/RegistrationPageOptions";
import EventCardList from "./EventCardList";
import '../Styles/ParentConsent.scss';
import { vi } from "date-fns/locale";

function ParentConsent({ buddyFirstName, setBuddyFirstName, buddyLastName, previousPage, nextPage,
   setBuddyLastName, authorizedIndividuals, setAuthorizedIndividuals, setSelectedPage, parentSignature, setParentSignature, parentSignatureDate, setParentSignatureDate }) {
   var currentDate = new Date().toLocaleDateString();

   const [emptyParentSignatureError, setEmptyParentSignatureError] = useState(false)
   const [emptyAuthorizedIndividualOneFirstNameError, setEmptyAuthorizedIndividualOneFirstNameError] = useState(false)
   const [emptyAuthorizedIndividualOneLastNameError, setEmptyAuthorizedIndividualOneLastNameError] = useState(false)
   const [emptyAuthorizedIndividualOneRelationshipError, setEmptyAuthorizedIndividualOneRelationshipError] = useState(false)
   const [emptyAuthorizedIndividualOnePhoneError, setEmptyAuthorizedIndividualOnePhoneError] = useState(false)
   const [invalidAuthorizedIndividualOnePhoneError, setInvalidAuthorizedIndividualOnePhoneError] = useState(false)
   const [invalidAuthorizedIndividualTwoPhoneError, setInvalidAuthorizedIndividualTwoPhoneError] = useState(false)
   const [invalidAuthorizedIndividualThreePhoneError, setInvalidAuthorizedIndividualThreePhoneError] = useState(false)
   const [invalidAuthorizedIndividualFourPhoneError, setInvalidAuthorizedIndividualFourPhoneError] = useState(false)
   const [invalidAuthorizedIndividualFivePhoneError, setInvalidAuthorizedIndividualFivePhoneError] = useState(false)
   const [invalidAuthorizedIndividualSixPhoneError, setInvalidAuthorizedIndividualSixPhoneError] = useState(false)
   const [visibleAuthorizedIndividuals, setVisibleAuthorizedIndividuals] = useState(1)


   console.log(authorizedIndividuals, "authorized individuals")

   function ValidatePersonalInformation() {
      let isError = false

      if (parentSignature === "") {
         setEmptyParentSignatureError(true)
         isError = true
      }

      if (authorizedIndividuals.individualOneFirstName === "") {
         setEmptyAuthorizedIndividualOneFirstNameError(true)
         isError = true;
      }
      if (authorizedIndividuals.individualOneLastName === "") {
         setEmptyAuthorizedIndividualOneLastNameError(true)
         isError = true;
      }
      if (authorizedIndividuals.individualOneRelationship === "") {
         setEmptyAuthorizedIndividualOneRelationshipError(true)
      }
      if (authorizedIndividuals.individualOnePhone === "") {
         setEmptyAuthorizedIndividualOnePhoneError(true)
         isError = true;
      }
      if (authorizedIndividuals.individualOnePhone != "") {
         const condition = /^(\(\d{3}\)\s\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{10})$/
         if (condition.test(authorizedIndividuals.individualOnePhone) === false) {
            setInvalidAuthorizedIndividualOnePhoneError(true)
            isError = true
         }
      }
      console.log(authorizedIndividuals.individualTwoPhone, "Two phone")
      if (authorizedIndividuals.individualTwoPhone != "") {
         const condition = /^(\(\d{3}\)\s\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{10})$/
         if (condition.test(authorizedIndividuals.individualTwoPhone) === false) {
            setInvalidAuthorizedIndividualTwoPhoneError(true)
            isError = true
         }
      }
      if (authorizedIndividuals.individualThreePhone != "") {
         const condition = /^(\(\d{3}\)\s\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{10})$/
         if (condition.test(authorizedIndividuals.individualThreePhone) === false) {
            setInvalidAuthorizedIndividualThreePhoneError(true)
            isError = true
         }
      }
      if (authorizedIndividuals.individualFourPhone != "") {
         const condition = /^(\(\d{3}\)\s\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{10})$/
         if (condition.test(authorizedIndividuals.individualFourPhone) === false) {
            setInvalidAuthorizedIndividualFourPhoneError(true)
            isError = true
         }
      }
      if (authorizedIndividuals.individualFivePhone != "") {
         const condition = /^(\(\d{3}\)\s\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{10})$/
         if (condition.test(authorizedIndividuals.individualFivePhone) === false) {
            setInvalidAuthorizedIndividualFivePhoneError(true)
            isError = true
         }
      }
      if (authorizedIndividuals.individualSixPhone != "") {
         const condition = /^(\(\d{3}\)\s\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{10})$/
         if (condition.test(authorizedIndividuals.individualSixPhone) === false) {
            setInvalidAuthorizedIndividualSixPhoneError(true)
            isError = true
         }
      }

      if (isError == false) {
         setSelectedPage(nextPage)
      }
   }

   function handleAuthorizedIndividuals() {

      console.log("Are we trying?")
      if (visibleAuthorizedIndividuals === 1) {
         setAuthorizedIndividuals({
            ...authorizedIndividuals,
            individualTwoFirstName: "",
            individualTwoLastName: "",
            individualTwoRelationship: "",
            individualTwoPhone: ""
         })
      }
      if (visibleAuthorizedIndividuals === 2) {
         setAuthorizedIndividuals({
            ...authorizedIndividuals,
            individualThreeFirstName: "",
            individualThreeLastName: "",
            individualThreeRelationship: "",
            individualThreePhone: ""
         })
      }
      if (visibleAuthorizedIndividuals === 3) {
         setAuthorizedIndividuals({
            ...authorizedIndividuals,
            individualFourFirstName: "",
            individualFourLastName: "",
            individualFourRelationship: "",
            individualFourPhone: ""
         })
      }
      if (visibleAuthorizedIndividuals === 4) {
         setAuthorizedIndividuals({
            ...authorizedIndividuals,
            individualFiveFirstName: "",
            individualFiveLastName: "",
            individualFiveRelationship: "",
            individualFivePhone: ""
         })
      }
      if (visibleAuthorizedIndividuals === 5) {
         setAuthorizedIndividuals({
            ...authorizedIndividuals,
            individualSixFirstName: "",
            individualSixLastName: "",
            individualSixRelationship: "",
            individualSixPhone: ""

         })
      }
   }

   useEffect(() => {
      handleAuthorizedIndividuals()
   }, [visibleAuthorizedIndividuals]);

   return (
         <div className="ParentConsentContent">
            <div className="ParentConsentHeading">
               Parent Consent
            </div>
            <div className="ParentConsentExplanation">
               All campers must have this signed by a parent or guardian.
            </div>
            <div className="ParentConsentText">
               I hereby give permission for my child/dependent to take part in all Ranch activities including sports and horseback riding (unless otherwise indicated) and absolve the Ranch from
               liability to me or my child because of any injury received while attending camp at the Bill Rice Ranch. In case of any accident or serious illness, I hereby authorize the Ranch to call
               upon a physician of their choice and to follow his instructions. If emergency treatment or hospitalization is required, I request the Ranch to notify me. I give my consent to the Ranch
               to include picture, video, or other likenesses of myself or my children in promotional materials.<br></br><br></br>
               Staff is authorized to release my above named child to the individuals listed below or to me ONLY and in accordance with the stated pick-up procedures. I understand that my child
               will NOT be permitted to leave the camp with anyone not listed below. All authorized individuals will be required to show identification in order to pick up my child each day.
            </div>
            <div className="ParentConsentParentSignature">
               <div className="ParentConsentParentSignatureHeading">
                  Signature
               </div>
               <div className="ParentConsentSignatureFields">
                  <div className="ParentConsentSignatureText">
                     {emptyParentSignatureError === true &&
                        <div className="EmptyParentSignature">
                           * A Signature Must Be Provided
                        </div>
                     }
                     <label>Parent/Guardian</label>
                     <input
                        type="text"
                        required
                        value={parentSignature}
                        onChange={(event) => {
                           setParentSignature(event.target.value)
                           setEmptyParentSignatureError(false)
                        }}
                     />
                  </div>
                  <div className="ParentConsentSignatureDate">
                     <label>Date<br></br>{currentDate}&nbsp;</label>
                     {setParentSignatureDate(currentDate)}
                  </div>
               </div>
            </div>
            <div className="ParentConsentAuthorizedIndividuals">
               <div className="ParentConsentAuthorizedIndividualsHeading">
                  Authorized Individuals - Provide at least one.
               </div>
               <div className="ParentConsentAuthorizedIndividualsAddOrRemoveButtons">
                  {visibleAuthorizedIndividuals < 6 &&
                     <button className="AuthorizedIndividualsAddButton" onClick={() => setVisibleAuthorizedIndividuals(visibleAuthorizedIndividuals + 1)}>
                        Add Individual
                     </button>
                  }
                  {visibleAuthorizedIndividuals > 1 &&
                     <button className="AuthorizedIndividualsRemoveButton" onClick={() => setVisibleAuthorizedIndividuals(visibleAuthorizedIndividuals - 1)}>
                        Remove Individual
                     </button>
                  }
               </div>
               <div className="ParentConsentAuthorizedIndividualsFields">
                  {visibleAuthorizedIndividuals >= 1 &&
                     <div className="AuthorizedIndividualOne">
                        <div className="AuthorizedIndividualOneFirstName">
                           <form>
                              {emptyAuthorizedIndividualOneFirstNameError === true &&
                                 <div className="EmptyAuthorizedIndividualOneFirstName">
                                    * Authorized Individual One First Name Is Required.
                                 </div>
                              }
                              <label>Individual One First Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualOneFirstName}
                                 onChange={(event) => {
                                    setAuthorizedIndividuals({ ...authorizedIndividuals, individualOneFirstName: (event.target.value) })
                                    setEmptyAuthorizedIndividualOneFirstNameError(false)
                                 }}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualOneLastName">
                           <form>
                              {emptyAuthorizedIndividualOneLastNameError === true &&
                                 <div className="EmptyAuthorizedIndividualOneLastName">
                                    * Authorized Individual One Last Name Is Required.
                                 </div>
                              }
                              <label>Individual One Last Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualOneLastName}
                                 onChange={(event) => {
                                    setAuthorizedIndividuals({ ...authorizedIndividuals, individualOneLastName: (event.target.value) })
                                    setEmptyAuthorizedIndividualOneLastNameError(false)
                                 }}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualOneRelationship">
                           <form>
                              {emptyAuthorizedIndividualOneRelationshipError === true &&
                                 <div className="EmptyAuthorizedIndividualRelationshipName">
                                    * Authorized Individual One Relationship Is Required.
                                 </div>
                              }
                              <label>Individual One Relationship</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualOneRelationship}
                                 onChange={(event) => {
                                    setAuthorizedIndividuals({ ...authorizedIndividuals, individualOneRelationship: (event.target.value) })
                                    setEmptyAuthorizedIndividualOneRelationshipError(false)
                                 }}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualOnePhone">
                           <form>
                              {emptyAuthorizedIndividualOnePhoneError === true &&
                                 <div className="EmptyAuthorizedIndividualOnePhoneName">
                                    * Authorized Individual One Phone Number Is Required.
                                 </div>
                              }
                              {invalidAuthorizedIndividualOnePhoneError === true &&
                                 <div className="InvalidAuthorizedIndividualOnePhoneName">
                                    * Phone number must be formatted as such: (123) 456-7890, 123-456-7890, or 1234567890
                                 </div>
                              }
                              <label>Individual One Phone </label>
                              <input
                                 type="tel"
                                 required
                                 maxLength={14}
                                 value={authorizedIndividuals.individualOnePhone}
                                 onChange={(event) => {
                                    setAuthorizedIndividuals({ ...authorizedIndividuals, individualOnePhone: (event.target.value) })
                                    setEmptyAuthorizedIndividualOnePhoneError(false)
                                    setInvalidAuthorizedIndividualOnePhoneError(false)
                                 }} />
                           </form>
                        </div>
                     </div>
                  }
                  {visibleAuthorizedIndividuals >= 2 &&
                     <div className="AuthorizedIndividualTwo">
                        <div className="AuthorizedIndividualTwoFirstName">
                           <form>
                              <label>Individual Two First Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualTwoFirstName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualTwoFirstName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualTwoLastName">
                           <form>
                              <label>Individual Two Last Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualTwoLastName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualTwoLastName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualTwoRelationship">
                           <form>
                              <label>Individual Two Relationship</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualTwoRelationship}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualTwoRelationship: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualTwoPhone">
                           <form>
                              {invalidAuthorizedIndividualTwoPhoneError === true &&
                                 <div className="InvalidAuthorizedIndividualTwoPhoneName">
                                    * Phone number must be formatted as such: (123) 456-7890, 123-456-7890, or 1234567890
                                 </div>
                              }
                              <label>Individual Two Phone </label>
                              <input
                                 type="tel"
                                 required
                                 maxLength={12}
                                 value={authorizedIndividuals.individualTwoPhone}
                                 onChange={(event) => {
                                    setAuthorizedIndividuals({ ...authorizedIndividuals, individualTwoPhone: (event.target.value) })
                                    setInvalidAuthorizedIndividualTwoPhoneError(false)
                                 }} />
                           </form>
                        </div>
                     </div>
                  }
                  {visibleAuthorizedIndividuals >= 3 &&
                     <div className="AuthorizedIndividualThree">
                        <div className="AuthorizedIndividualThreeFirstName">
                           <form>
                              <label>Individual Three First Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualThreeFirstName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualThreeFirstName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualThreeLastName">
                           <form>
                              <label>Individual Three Last Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualThreeLastName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualThreeLastName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualThreeRelationship">
                           <form>
                              <label>Individual Three Relationship</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualThreeRelationship}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualThreeRelationship: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualThreePhone">
                           <form>
                              {invalidAuthorizedIndividualThreePhoneError === true &&
                                 <div className="InvalidAuthorizedIndividualThreePhoneName">
                                    * Phone number must be formatted as such: (123) 456-7890, 123-456-7890, or 1234567890
                                 </div>
                              }
                              <label>Individual Three Phone </label>
                              <input
                                 type="tel"
                                 required
                                 maxLength={12}
                                 value={authorizedIndividuals.individualThreePhone}
                                 onChange={(event) => {
                                    setAuthorizedIndividuals({ ...authorizedIndividuals, individualThreePhone: (event.target.value) })
                                    setInvalidAuthorizedIndividualThreePhoneError(false)
                                 }} />
                           </form>
                        </div>
                     </div>
                  }
                  {visibleAuthorizedIndividuals >= 4 &&
                     <div className="AuthorizedIndividualFour">
                        <div className="AuthorizedIndividualFourFirstName">
                           <form>
                              <label>Individual Four First Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualFourFirstName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualFourFirstName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualFourLastName">
                           <form>
                              <label>Individual Four Last Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualFourLastName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualFourLastName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualFourRelationship">
                           <form>
                              <label>Individual Four Relationship</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualFourRelationship}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualFourRelationship: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualFourPhone">
                           <form>
                              {invalidAuthorizedIndividualFourPhoneError === true &&
                                 <div className="InvalidAuthorizedIndividualFourPhoneName">
                                    * Phone number must be formatted as such: (123) 456-7890, 123-456-7890, or 1234567890
                                 </div>
                              }
                              <label>Individual Four Phone </label>
                              <input
                                 type="tel"
                                 required
                                 maxLength={12}
                                 value={authorizedIndividuals.individualFourPhone}
                                 onChange={(event) => {
                                    setAuthorizedIndividuals({ ...authorizedIndividuals, individualFourPhone: (event.target.value) })
                                    setInvalidAuthorizedIndividualFourPhoneError(false)
                                 }} />
                           </form>
                        </div>
                     </div>
                  }
                  {visibleAuthorizedIndividuals >= 5 &&
                     <div className="AuthorizedIndividualFive">
                        <div className="AuthorizedIndividualFiveFirstName">
                           <form>
                              <label>Individual Five First Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualFiveFirstName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualFiveFirstName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualFiveLastName">
                           <form>
                              <label>Individual Five Last Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualFiveLastName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualFiveLastName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualFiveRelationship">
                           <form>
                              <label>Individual Five Relationship</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualFiveRelationship}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualFiveRelationship: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualFivePhone">
                           <form>
                              {invalidAuthorizedIndividualFivePhoneError === true &&
                                 <div className="InvalidAuthorizedIndividualFivePhoneName">
                                    * Phone number must be formatted as such: (123) 456-7890, 123-456-7890, or 1234567890
                                 </div>
                              }
                              <label>Individual Five Phone </label>
                              <input
                                 type="tel"
                                 required
                                 maxLength={12}
                                 value={authorizedIndividuals.individualFivePhone}
                                 onChange={(event) => {
                                    setAuthorizedIndividuals({ ...authorizedIndividuals, individualFivePhone: (event.target.value) })
                                    setInvalidAuthorizedIndividualFivePhoneError(false)
                                 }} />
                           </form>
                        </div>
                     </div>
                  }
                  {visibleAuthorizedIndividuals >= 6 &&
                     <div className="AuthorizedIndividualSix">
                        <div className="AuthorizedIndividualSixFirstName">
                           <form>
                              <label>Individual Six First Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualSixFirstName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualSixFirstName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualSixLastName">
                           <form>
                              <label>Individual Six Last Name</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualSixLastName}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualSixLastName: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualSixRelationship">
                           <form>
                              <label>Individual Six Relationship</label>
                              <input
                                 type="text"
                                 required
                                 value={authorizedIndividuals.individualSixRelationship}
                                 onChange={(event) => setAuthorizedIndividuals({ ...authorizedIndividuals, individualSixRelationship: (event.target.value) })}
                              />
                           </form>
                        </div>
                        <div className="AuthorizedIndividualSixPhone">
                           <form>
                              {invalidAuthorizedIndividualSixPhoneError === true &&
                                 <div className="InvalidAuthorizedIndividualSixPhoneName">
                                    * Phone number must be formatted as such: (123) 456-7890, 123-456-7890, or 1234567890
                                 </div>
                              }
                              <label>Individual Six Phone </label>
                              <input
                                 type="tel"
                                 required
                                 maxLength={12}
                                 value={authorizedIndividuals.individualSixPhone}
                                 onChange={(event) => {
                                    setAuthorizedIndividuals({ ...authorizedIndividuals, individualSixPhone: (event.target.value) })
                                    setInvalidAuthorizedIndividualSixPhoneError(false)
                                 }} />
                           </form>
                        </div>
                     </div>
                  }
               </div>
               {(emptyParentSignatureError || emptyAuthorizedIndividualOneFirstNameError || emptyAuthorizedIndividualOneLastNameError ||
                     emptyAuthorizedIndividualOneRelationshipError || emptyAuthorizedIndividualOnePhoneError || invalidAuthorizedIndividualOnePhoneError ||
                     invalidAuthorizedIndividualTwoPhoneError || invalidAuthorizedIndividualThreePhoneError || invalidAuthorizedIndividualFourPhoneError ||
                     invalidAuthorizedIndividualFivePhoneError || invalidAuthorizedIndividualSixPhoneError) &&
                     <div className="ParentConsentErrorMessage">
                        Please correct the above error(s):
                     </div>
                  }
            </div>
            <div className="ParentConsentButtons">
               <div className="ParentConsentPreviousButton">
                  <button className='prevButton' onClick={() => setSelectedPage(previousPage)}>
                     Previous
                  </button>
               </div>
               <div className="ParentConsentNextButton">
                  <div style={{ color: 'green', margin: '15px, 0', fontFamily: 'Sen' }}></div>
                  <button className="nextButton" onClick={() => ValidatePersonalInformation()}>
                     Next
                  </button>
               </div>
            </div>
      </div>
   )
}
export default ParentConsent
